import { GET_PLANS } from '@/app/Api/Route_API';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '@/utils/axiosInstance';

export const getPricingList = createAsyncThunk(
  'price/getPricingList',
  async (_, { rejectWithValue }) => {
    try {
        
      const response = await axios.get(GET_PLANS);
      
      if(response?.data?.status === true){
        return response?.data?.data;
      }
      
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Slice
const PriceSlice = createSlice({
    name: 'price',
  initialState: {
    price: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPricingList.fulfilled, (state, action) => {
    
        
        state.price = action.payload;
        state.status = 'succeeded';
        state.error = null;
      })
      .addCase(getPricingList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
     
;
  },
});

export default PriceSlice.reducer;